import styled from "styled-components";
import { Form } from "formik";
import { Modal } from "react-bootstrap";

export const ModalStyle = styled(Modal)`
  .modal-content {
    padding: 26px;
    border-radius: 10px;
    max-width: 500px;
    width: 100%;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  span {
    color: #808495;
    font-size: 1.125rem;
  }
  svg {
    cursor: pointer;
    color: #074f8c;
  }
`;

export const Title = styled.h1`
  margin: 0;
  color: #074f8c;
  font-size: 1.25rem;
  font-weight: 400;
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  button {
    width: 100%;
  }
  button:first-child {
    margin-right: 20px;
  }
`;

export const Messenger = styled.span`
  font-size: 0.8125rem;
  color: #8f8f8f;
`;

export const FormContainer = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 30px;
`;

export const Container = styled.div`
  margin-top: 20px;
`;

export const SecondFieldContainer = styled.div`
  width: 90px;
  margin-left: 10px;

`;

export const FieldContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  div {
    width: 100%;
  }

  @media (max-width: 380px) {
    flex-flow: wrap;
  }
  
  ${SecondFieldContainer} {
    width: 90px;
    @media (max-width: 380px) {
      width: 100%;
      margin-left: 0;
      margin-top: 20px;
    }
  }
`;


